import { Component } from '@angular/core';
import { Menu } from './menu';
import { ActivatedRoute, Route, Router } from '@angular/router';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent {
  listmenu:any = [];
  page:number = 1;


  constructor(private router:Router){
    this.listmenu = Menu;
  }

  changepage(data:any){

    if(data){
      this.page = data.id;
      const link:string = data?.link || '/';
      this.router.navigate([link])
    }
  }
}

